// Base
import { BaseApi } from '../base.api'

// Interface
import {
  IAssessorWebpageApi,
  IAssessorWebpageApiRequest,
  IAssessorWebpageApiResponse,
  IAssessorWebpageApiGetAttrs,
} from 'interfaces/webpage/assessor/assessor-api.interface'

// Constant
import { ApiConstant } from 'constant'
import { axios_renderUrl } from 'utils'

export class AssessorWebpageApi extends BaseApi<IAssessorWebpageApi> implements IAssessorWebpageApiRequest {
  readonly url = ApiConstant.ASSESSOR_URL
  private assessorUrl = axios_renderUrl(this.url, ApiConstant.WEBPAGE)

  /**
   * @description Get Assessor Webpage
   *
   * @method POST
   * @access public
   *
   * @param {IAssessorWebpageApiGetAttrs} payload
   *
   * @return {Promise<IAssessorWebpageApiResponse>} Promise<IAssessorWebpageApiResponse>
   */
  async assessorWebpage_getAssessor(payload: IAssessorWebpageApiGetAttrs): Promise<IAssessorWebpageApiResponse> {
    try {
      const response: IAssessorWebpageApiResponse = await this.POST(this.assessorUrl, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
